import { render } from "./QuanTriDanhMuc.vue?vue&type=template&id=75d0117c&scoped=true"
import script from "./QuanTriDanhMuc.vue?vue&type=script&lang=js"
export * from "./QuanTriDanhMuc.vue?vue&type=script&lang=js"

import "./QuanTriDanhMuc.vue?vue&type=style&index=0&id=75d0117c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d0117c"]])

export default __exports__